module.exports = __webpack_public_path__ + "img/icon_golden_followers_2.368ab7a5.png";